import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Value = (props) => {
  return (
    <FormGroup controlId="value">
      <Col componentClass={ControlLabel} sm={5}>
        Value
      </Col>
    <Col sm={7}>
        <FormControl
          type="number"
          value={props.value}
          onChange={props.handleChangeValue}
          autoComplete="off"
          disabled={props.validDisabled}
          />
    </Col>
    </FormGroup>
  )
}

Value.propTypes = {
  value: PropTypes.string,
  handleChangeValue: PropTypes.func,
  validDisabled: PropTypes.bool
};

export default Value;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/value/Value.js